export default {"src":"/_next/static/media/profile-card.e78e0131.svg","height":513,"width":513};